import * as React from "react";
import { useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import Avatar from "@mui/material/Avatar";
import { DialogContent } from "@mui/material";
import IconView from "../../../../Contents/FontIcons/IconView";
import LoanCalculator from "./LoanCalculator";
import DisplayBothLetters from "./DisplayBothLetters";



export default function CalculatorDialogue(props) {

  const [open, setOpen] = React.useState(false);
  const {type,Bgcolor,name} = props;
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false); 
  };



  // Get List of Qualification from the server

  React.useEffect(() => {
   
  }, []);
 
  return (
    <div className="appicant-profile-dialog-con w-500rem ">
      <Button sx={{backgroundColor:Bgcolor, marginRight:"1em"}} variant="contained" onClick={handleClickOpen}>
        {
          props.userTYpe === "bankreviewer" ? <span>Evaluate Loan - Bank Reviewer</span> :
          props.userTYpe === "disbursement" ? <span>See Loan Evalaution</span> : props.userTYpe === "request-letter" ? props.changeT  ? <span>{props.changeT}</span> : <span>Generate Request Letter</span>  :
          <span>Evaluate Loan</span>
        }
       
        <IconView
          tooltipText="View Applicants Profile"
          tooltipColor="white"
          tooltipIconSize="19px"
        />
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        maxWidth=""
      >
        <DialogContent>
       
      


              {
                props.userTYpe === "request-letter" ? <DisplayBothLetters typeForUser={props.typeForUser} from={props.from} user_tokens={props.user_tokens} />:
                <LoanCalculator from={props.from}  program_type={props.loanrequest?.program_type || ""} guarantor={`${props.guarantor?.first_name} ${props.guarantor?.middle_name} ${props.guarantor?.surname}`}  email={props.email} Sponsor={`${props.Sponsor?.first_name} ${props.Sponsor?.middle_name} ${props.Sponsor?.surname}`} Student={`${props.Student?.fname} ${props.Student?.md_name} ${props.Student?.lname}`} user_tokens={props.user_tokens} loanAmount={props.loanAmount} tenor={props.tenor} />

              }      
              
              

        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          {/* <Button onClick={handleClose} autoFocus>
            Agree
          </Button> */}
        </DialogActions>
      </Dialog>
    </div>
  );
}
